import { Util } from '@/modules/util'
import { Request } from '@/classes/Request.ts'

export interface SignedDocumentInstance {
  instanceId: number
  templateId: number
  templateName: string
  status: string
  studentAccountId: number | null
  studentName: string | null
  masterEnrollmentId: number | null
  renderedPdfAvailable: boolean
  completedAt: string | null
  createdDate: string | null
}

/**
 * GET /ajax/documents/signed — every document instance made from the logged-in
 * family's enrollment answers.
 */
export const listSignedDocuments = async (): Promise<SignedDocumentInstance[]> => {
  const response = await new Request().get('/ajax/documents/signed')
  return Util.Obj.keysToCamel(response.data.documents ?? []) as SignedDocumentInstance[]
}
